// these APIs are auto-imported from @vueuse/core
export const isDark = useDark({ initialValue: 'light' })
export const toggleDark = useToggle(isDark)
export const preferredDark = usePreferredDark()
